import { render, staticRenderFns } from "./SalesProductivityContent.vue?vue&type=template&id=4935d5a5&"
import script from "./SalesProductivityContent.vue?vue&type=script&lang=js&"
export * from "./SalesProductivityContent.vue?vue&type=script&lang=js&"
import style0 from "./SalesProductivityContent.vue?vue&type=style&index=0&id=4935d5a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports